module.exports = __webpack_public_path__ + "static/media/close.2a67696f.svg";